import {
  defaultSystemCode,
  defaultUserCardLost,
  exists,
  SystemCode,
  SystemCodeFromJSON,
  UserCardLost,
  UserCardLostFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface UserBase {
  id: string
  userType: SystemCode
  status: SystemCode
  registeredDate: string
  expirationDate: string
  branchCode: SystemCode
  myBranchCode: SystemCode
  myPlaceCode: SystemCode
  reserveReceivePlaceCode: SystemCode
  reserveNotice: SystemCode
  readingSupportEnabled: boolean
  cardLost: UserCardLost
  ppid: string
  revision: number
  felicaId: string
}

export function UserBaseFromJSON(json: any): UserBase {
  return {
    id: json.id,
    userType: exists(json, 'user_type')
      ? SystemCodeFromJSON(json.user_type)
      : defaultSystemCode(),
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    registeredDate: exists(json, 'registered_date')
      ? dateToPlainFormat(json.registered_date)
      : '',
    expirationDate: exists(json, 'expiration_date')
      ? dateToPlainFormat(json.expiration_date)
      : '',
    branchCode: exists(json, 'branch_code')
      ? SystemCodeFromJSON(json.branch_code)
      : defaultSystemCode(),
    myBranchCode: exists(json, 'my_branch_code')
      ? SystemCodeFromJSON(json.my_branch_code)
      : defaultSystemCode(),
    myPlaceCode: exists(json, 'my_place_code')
      ? SystemCodeFromJSON(json.my_place_code)
      : defaultSystemCode(),
    reserveReceivePlaceCode: exists(json, 'reserve_receive_place_code')
      ? SystemCodeFromJSON(json.reserve_receive_place_code)
      : defaultSystemCode(),
    reserveNotice: exists(json, 'reserve_notice')
      ? SystemCodeFromJSON(json.reserve_notice)
      : defaultSystemCode(),
    readingSupportEnabled: exists(json, 'reading_support_enabled')
      ? json.reading_support_enabled
      : false,
    cardLost: UserCardLostFromJSON(json.card_lost),
    ppid: exists(json, 'ppid') ? json.ppid : '',
    revision: json.revision,
    felicaId: exists(json, 'felica_id') ? json.felica_id : ''
  }
}

export const defaultUserBase = (): UserBase => ({
  id: '',
  userType: defaultSystemCode(),
  status: defaultSystemCode(),
  registeredDate: '',
  expirationDate: '',
  branchCode: defaultSystemCode(),
  myBranchCode: defaultSystemCode(),
  myPlaceCode: defaultSystemCode(),
  reserveReceivePlaceCode: defaultSystemCode(),
  reserveNotice: defaultSystemCode(),
  readingSupportEnabled: false,
  cardLost: defaultUserCardLost(),
  ppid: '',
  revision: 1,
  felicaId: ''
})
